import * as API from "../../api";
import * as ActionTypes from "../action-types";

import { get_employer_list_no_coid_request } from "./employer";

import { message } from "antd";
import {
  setLoadingCompany,
  unsetLoadingCompany,
} from "./style";

export const get_all_company_request = () => (dispatch) => {
  dispatch(setLoadingCompany());
  API.getAllCompany()
    .then((info) => {
      const { status, msg, companies } = info;

      if (status === 200) {
        dispatch(get_all_company_success(companies));
        message.success("Successfully get the company data");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingCompany());
    });
};

const get_all_company_success = (company) => {
  return {
    type: ActionTypes.COMPANY_GET_ALL,
    company,
  };
};

export const get_company_thru_coid_request = (coid) => (dispatch) => {
  dispatch(setLoadingCompany());
  API.getCompanyThruCoid(coid)
    .then((info) => {
      const { status, msg, company } = info;

      if (status === 200) {
        dispatch(get_company_thru_coid_success(company));
        message.success("Successfully get the company data");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingCompany());
    });
};

const get_company_thru_coid_success = (company) => {
  return {
    type: ActionTypes.GET_COMPANY_THRU_COID,
    company,
  };
};

export const create_company_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingCompany());

  API.createCompany(items)
    .then((data) => {
      if (data && data.status && data.company) {
        const { status, company, msg } = data;
        if (status === 200) {
          dispatch(create_company_success(company));
          dispatch(get_employer_list_no_coid_request())
          message.success("Update company successfully");
        } else {
          message.warning(msg);
        }
      } else {
        message.error("Unexpected response from the server");
      }
    })
    .catch((error) => {
      console.error("Error in Update Company :", error.message);
      message.error("Failed to update company. Please try again later.");
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingCompany());
    });
};

const create_company_success = (company) => {
  return {
    type: ActionTypes.CREATE_COMPANY,
    company,
  };
};

export const update_company_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingCompany());

  API.updateCompany(items)
    .then((data) => {
      const { status, company, msg, remarkCount } = data;
      if (status === 200) {
        dispatch(update_company_success(company));
        dispatch(update_remarkcount_company_success({refid: company.coid, remarkCount}))
        message.success("Update company successfully");
        cb({ status: 200 });
      } else {
        cb({ status: status });
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingCompany());
    });
};

const update_company_success = (company) => {
  return {
    type: ActionTypes.UPDATE_COMPANY,
    company,
  };
};

export const update_remarkcount_company_success = (remark) => {
  return {
    type: ActionTypes.UPDATE_REMARKCOUNT_COMPANY,
    remark,
  };
};
